module.exports = __webpack_public_path__ + "static/naomie-246f4769df498147e4c53d72f39a4cad.png";